/*
 * @Description:
 * @Date: 2025-09-12 16:05:57
 */

import { formatter } from '@/utils';

export const getInvoiceItemTranslator = resp => {
  resp.data = resp.data.map(item => {
    return {
      ...item,
      value: item.id,
      label: [item.code, item.topLevelCategory, item.subcategory]
        .filter(Boolean)
        .join('/')
    };
  });
  return resp;
};
export const individualInfoDetailTranslator = resp => {
  const data = resp.data;
  data.invoiceItemIdList = getInvoiceItemTranslator({
    data: data.invoiceItemIdList
  }).data;
  // 兼容：将旧的 subItemId/subItemName 标量转为新的 subItem 数组结构
  data.invoiceItemIdList = data.invoiceItemIdList.map(item => ({
    ...item,
    subItem:
      item.subItemId != null
        ? [{ id: item.subItemId, name: item.subItemName }]
        : item.subItem || []
  }));
  // 再次提交时需要格式化原值
  data.expiraStart = data.expiraStart
    ? formatter.date(data.expiraStart, 'YYYY-MM-DD')
    : '';
  data.expiraEnd = data.expiraEnd
    ? formatter.date(data.expiraEnd, 'YYYY-MM-DD')
    : '';
  data.historyExpiraDateList = (data.historyExpiraDateList || []).map(item => {
    return {
      ...item,
      startAt: formatter.date(item.startAt, 'YYYY-MM-DD'),
      endAt: formatter.date(item.endAt, 'YYYY-MM-DD')
    };
  });
  data._fileList = data.entpCertPic ? [{ url: data.entpCertPic }] : [];
  data._expira = data.expiraEnd ? [data.expiraStart, data.expiraEnd] : [];
  data._invoiceType = data.invoiceType === 3 ? [1, 2] : [data.invoiceType];

  return resp;
};
export const addIndividualPayloadTranslator = payload => {
  return {
    ...payload,
    /* 默认值 */
    entpCertType: 1,
    enable: 1,
    /* 映射数据 */
    ...(payload?._fileList?.[0]?.url && {
      entpCertPic: payload?._fileList[0]?.url
    }),
    ...(payload?._expira?.[0] && {
      expiraStart: payload?._expira[0]
    }),
    ...(payload?._expira?.[1] && {
      expiraEnd: payload?._expira[1]
    }),
    ...(payload?._invoiceType?.length && {
      invoiceType:
        payload?._invoiceType.length > 1 ? 3 : payload._invoiceType[0]
    })
  };
};
